import api from "./axios";

class ServiceNfseItem {
  async save(idService) {
    const { data } = await api.post("/nfse-item", idService)
    return data
  }

  async update(data) {
    await api.put(`/nfse-item/${data.id}`, data);
  }

  async delete(idService, idNfse = null) {
    await api.delete(`/nfse-item/${idService}/${idNfse}`)
  }

  async getItemForGrid(id) {
    const { data } = await api.get(`/nfse-item/items/${id}`)
    return data;
  }
    async downloadSingleXml(id, number) {
    if (!id) return

    const { data } = await api.get(`/nfse-item/download/single/xml/${id}`, {
      responseType: 'blob',
    })

    const href = URL.createObjectURL(data);

    const link = document.createElement('a');
    link.href = href;

    link.setAttribute('download', `${number ? number : 'nfse'}.xml`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }
}
export default new ServiceNfseItem()